import { CompositeScreenProps } from '@react-navigation/native'
import React, { useEffect, useState } from 'react'

import { Page } from 'partials/Page'
import { PostPlayer } from 'partials/PostPlayer'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { NoContent } from 'widgets/NoContent'
import { Text } from 'widgets/Text'

import { usePost } from 'hooks/usePost'

import { PlayerFooter } from './widgets/PlayerFooter'
import { PlayerHeader } from './widgets/PlayerHeader'

export const PostPage = ({ navigation, route }: CompositeScreenProps<any, any>) => {
  const postId = route?.params?.postId
  const completionId = route?.params?.completionId

  const { data: post, isLoading, isError } = usePost(postId)
  useEffect(() => {
    if (post && !post.id) {
      post.id = postId
    }
  }, [post, postId])
  // const { data: user } = useCurrentUser()
  // const isOwner = user?.id === post?.creator?.id

  const sections = post?.steps
  const [headerVisible, setHeaderVisible] = useState(true)
  const [currentSection, setCurrentSection] = useState(0)
  const [progress, setProgress] = useState(0)

  // useEffect(() => {
  //   if (post?.isPremium && !hasPremiumAccess && !isOwner) {
  //     Toast.error('No access', 'You must subscribe to this coach to view this post')
  //       navigation.navigate(links.GROUP_STACK, {
  //         screen: links.GROUP_PAGE,
  //          NOTE: This field will no longer exist on events due to denormalization.
  //         params: { username: post.creator.username },
  //       })
  //   }
  // }, [post, hasPremiumAccess, isOwner, navigation])

  // if (post?.isPremium && !hasPremiumAccess && !isOwner) {
  //   return null
  // }

  const handleHeaderVisibility = (visible: boolean) => {
    setHeaderVisible(visible)
  }

  return (
    <Page backgroundColor='greyDark' navigation={navigation}>
      {isError && <NoContent message='Error loading post' />}
      {isLoading ? (
        <Box display='flex' flex={1} justifyContent='center' align='center' height='100%'>
          <LoadingSpinner />
          <Box padding={{ vertical: 'sm' }}>
            <Text>Loading...</Text>
          </Box>
        </Box>
      ) : null}
      {post && (
        <PostPlayer
          post={post}
          sections={sections}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          setProgress={setProgress}
          setHeaderVisibility={handleHeaderVisibility}
        />
      )}
      {headerVisible && (
        <PlayerHeader
          post={post}
          progress={progress}
          currentStep={currentSection + 1}
          totalSteps={sections ? sections.length : 1}
        />
      )}
      {headerVisible && (
        <PlayerFooter
          post={post}
          postId={postId}
          completionId={completionId}
          currentStep={sections ? sections[currentSection] : undefined}
        />
      )}
    </Page>
  )
}
